import { ApiRole } from '../api/api-types/role.api';

export const roleMocks: ApiRole[] = [
	{
		id: '1',
		isActive: true,
		description: 'Ein Berater',
		shortName: 'Berater',
	},
	{
		id: '2',
		isActive: true,
		description: 'Fachkraft für irgendwas',
		shortName: 'Fachkraft',
	},
];
